import { defineMessages } from "react-intl";

import {
	diseasesMessages,
	hasDiseaseMessages,
	validator
} from "lib/build/forms/ktx/transplantation-screening/medical-history/otherDisorders";

import { FieldsetData } from "src/features/forms";
import { genericErrorMessages } from "src/messages/generic";
import { LeafNode } from "src/modules/shared/form-explorer";
const messages = defineMessages({
	otherDisorders: {
		id: "ktx.form.otherDisorders.title",
		defaultMessage: "Egyéb belgyógyászati betegség"
	},
	diseases: {
		id: "ktx.form.otherDisorders.value",
		defaultMessage: "Betegségek"
	},
	hasDisease: {
		id: "ktx.form.otherDisorders.hasDisease",
		defaultMessage: "Betegségek?"
	},
	comment: {
		id: "ktx.form.otherDisorders.comment",
		defaultMessage: "Megjegyzés"
	}
});

const fieldset: FieldsetData = {
	rows: [
		{
			columns: [
				{
					width: 12,
					field: {
						type: "field",
						path: ["hasDisease"],
						label: messages.hasDisease,
						errorMessages: genericErrorMessages,
						input: {
							type: "button-group",
							props: {
								labels: hasDiseaseMessages
							}
						}
					}
				}
			]
		},
		{
			columns: [
				{
					width: 12,
					field: {
						type: "field",
						path: ["diseases"],
						label: messages.diseases,
						errorMessages: genericErrorMessages,
						input: {
							type: "checkbox-group",
							props: {
								labels: diseasesMessages,
								direction: "vertical",
								columns: 2
							}
						}
					}
				}
			]
		},
		{
			columns: [
				{
					width: 12,
					field: {
						type: "field",
						path: ["comment"],
						label: messages.comment,
						errorMessages: genericErrorMessages,
						input: {
							type: "textarea",
							props: {}
						}
					}
				}
			]
		}
	]
};

export const node: LeafNode = {
	id: "ktx_otherDisorders",
	value: {
		schemaId: "otherDisorders",
		title: messages.otherDisorders,
		validator,
		fieldset,
		applyCurrentDate: false
	}
};
